import React from "react";
import { Form } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import { AddressApi } from "../../../lib-api";
import { apiConfiguration } from "../../../api-configuration";
import { theme } from "../../../util/theme";

const api = new AddressApi(apiConfiguration);

export interface AddressOption {
  value: string;
  label?: string;
  data: {
    city: string;
    postalCode: string;
    country: string;
  };
}

const promiseOptions = async (inputValue: string): Promise<AddressOption[]> => {
  if (!inputValue) {
    return [];
  }

  const results = await api.addressAutocomplete({ query: inputValue });

  return results.map((result) => ({
    value: result.id,
    label: result.title,
    data: {
      city: result.city,
      postalCode: result.postalCode,
      country: result.country,
    },
  }));
};

export const AddressPickerFormGroup: React.FC<{
  fieldName: string;
  fieldDisplayName: string;
  placeholder?: string;
  error?: any;
  value?: AddressOption;
  disabled: boolean;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T_1 = string | React.ChangeEvent<any>>(
      field: T_1
    ): T_1 extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
  className?: string;
}> = (props) => {
  return (
    <Form.Group className={props.className}>
      <Form.Label>{props.fieldDisplayName}</Form.Label>
      <AsyncSelect
        cacheOptions
        defaultOptions
        loadOptions={promiseOptions}
        placeholder={props.placeholder}
        isDisabled={props.disabled}
        loadingMessage={() => "Henter adresser..."}
        noOptionsMessage={() => "Ingen adresser fundet"}
        name={props.fieldName}
        value={props.value}
        onChange={(option) => {
          props.handleChange({
            target: { name: props.fieldName, value: option } as any,
          });
        }}
        styles={{
          control: (baseStyles) => ({
            ...baseStyles,
            borderColor: props.error ? theme.danger : theme.inputBorderColor,
          }),
          option: (baseStyles) => ({
            ...baseStyles,
            color: "black !important",
          }),
        }}
        isClearable
      />
      {props.error?.value && (
        <span className="text-danger">{props.error?.value}</span>
      )}
    </Form.Group>
  );
};
